import { Button } from '@doist/marketist';
import { Modal } from 'components/modal/modal';
import { useTranslation } from 'next-i18next';
import { getTemplateImportURL } from 'services/getTemplateImportURL';
import { IframePreview } from './iframe-preview/iframe-preview';
import type { DialogStore } from '@ariakit/react';
import type { TemplatePreview } from 'services/templates/types';
export type ModalPreviewProps = {
  store: DialogStore;
  template: TemplatePreview;
};
export function ModalPreview({
  store,
  template
}: ModalPreviewProps) {
  const {
    t
  } = useTranslation('templates');
  return <Modal title={template.name} store={store} buttons={[<Button key="use-template-btn" href={getTemplateImportURL(template.id)}>
                    {t(template.template_type === 'setup' ? 'useSetupButton' : 'useTemplateButton')}
                </Button>]} width="90vw" data-sentry-element="Modal" data-sentry-component="ModalPreview" data-sentry-source-file="modal-preview.tsx">
            <IframePreview template={template} iframeBlockSize="60vh" data-sentry-element="IframePreview" data-sentry-source-file="modal-preview.tsx" />
        </Modal>;
}